import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/annual/target',
    baseurl2:'/api',
    //--------------------------msgFunnel  网络对阵--------------------
    selectPage(query){
        return http({
            url: 'api/swyl/v1/annual/target/selectAnnualTargetPage',
            method: 'post',
            params: query
        });
    },
    selectUserByAgent(query){
        return http({
            url: '/api/swyl/v1/bscTargetAgainstUser/selectUserByAgent',
            method: 'post',
            params: query
        });
    },
    selectUserByUser(query){
        return http({
            url: '/api/swyl/v1/bscTargetAgainstUser/selectUserByUser',
            method: 'post',
            params: query
        });
    },
    deleteAnnualTarget(query){
        return http({
            url: 'api/swyl/v1/annual/target/delete',
            method: 'post',
            data: query
        });
    },
    // 抢单 客户
    selectPageCustom(query){
        return http({
            url: '/monthly/order/monthly/signing/list',
            method: 'get',
            params: query
        });
    },
    
}